import React from "react";
import "../component/Landing.css"
import Img6 from "../image/geo_acad.png"
import {Link} from "react-router-dom"

const FooterRight = () => {
    return (
        <footer className="landing_right">
            <Link to="/"><img src={Img6} alt="academi" /></Link><p> © 2025 Geoinfotech - Created by <a href="https://staff.geoinfotech.ng/" target="_blank" rel="noreferrer" style={{textDecoration: "none", color : "rgb(20, 115, 197)"}}>Geoinfotech Team</a></p>
        </footer>
    )
}

export default FooterRight